import * as React from "react";
import { connect } from "react-redux";
import Spinner from "../../components/spinner";
import Container from "../../components/container";
import { IStore } from "../../resources/types";

import styles from "./layout.module.css";

interface IProps {
  children: React.ReactChild | React.ReactChild[];
  layoutClass?: string;
  headerClass?: string;
  loading?: boolean;
}

function Layout({ children, loading, layoutClass }: IProps) {
  React.useEffect(() => {
    if (layoutClass) {
      document.body.classList.add(layoutClass);
    } else {
      document.body.classList.add(styles.bodyClass);
    }

    return () => {
      if (layoutClass) {
        document.body.classList.remove(layoutClass);
      }
      document.body.classList.remove(styles.bodyClass);
    };
  }, [layoutClass]);

  return (
    <div id="layout">
      <Container>{children}</Container>
      {loading && <Spinner />}
    </div>
  );
}

export default connect((state: IStore) => ({
  loading: state.loading
}))(Layout);
